<template>
  <div>
    <common-list
      ref="list"
      url="AccessoryEntryRecords/GetAccessoryOutStorageList"
      @currentrow="handlerCurrentRow"
    >
      <!-- 条件区域 -->
      <template v-slot:filter="{ filter }">
        <el-col :span="6">
          <el-form-item label="仓库名称" prop="WarehouseId">
            <RemoteSelect
              v-model="filter.WarehouseId"
              url="AccessoryEntryRecords/GetWareHouseList?WarehouseType=2"
              code="WarehouseId"
              name="WarehouseName"
              placeholder="选择仓库"
            >
            </RemoteSelect>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="配件名称" prop="PartsId">
            <RemoteSelect
              v-model="filter.PartsId"
              url="VehicleParts/GetList"
              code="PartsId"
              name="PartsName"
            >
            </RemoteSelect>
          </el-form-item>
        </el-col>
      </template>
      <!-- 按钮区域 -->
      <!-- <template v-slot:option>
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="add"
            v-if="auth('AccessoryStorageAdd')"
            >添加</el-button
          >
          <el-button
            type="warning"
            icon="el-icon-edit"
            @click="edit"
            v-if="auth('AccessoryStorageEdit')"
            >编辑</el-button
          >
          <el-button
            type="danger"
            icon="el-icon-delete"
            @click="deleteItem"
            v-if="auth('WareHouseDelete')"
            >删除</el-button
          >
          <el-button 
            type="blue" 
            icon="el-icon-tickets" 
            @click="show"
            v-if="auth('AccessoryStorageShow')"
            >查看</el-button
          >
        </template> -->
      <!-- 展示区域 -->
      <template v-slot:body>
        <el-table-column
          label="配件名称"
          prop="PartsName"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="入场编号"
          prop="Source"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="仓库名称"
          prop="WarehouseName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="数量"
          prop="Quantity"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="单位"
          prop="Unit"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="总重量" prop="Weight" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="出库人" prop="OutBy" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="出库日期" prop="OutTime" show-overflow-tooltip>
          <template slot-scope="scope">{{
            scope.row.OutTime | datetime("YYYY-MM-DD")
          }}</template>
        </el-table-column>
      </template>
    </common-list>
    <!-- 弹窗区域 Show -->
    <div>
      <AddEdit :item="itemAddEdit" @success="getData"></AddEdit>
      <Showdialog :item="itemShow"></Showdialog>
    </div>
  </div>
</template>
  
  <script>
import AddEdit from "./AddEdit";
import Showdialog from "./Show";
export default {
  components: {
    AddEdit,
    Showdialog,
  },
  data() {
    return {
      itemAddEdit: {},
      itemShow: {},
      showitem: [],
    };
  },
  computed: {},
  mounted() {},
  methods: {
    getData() {
      this.$refs.list.getTableData();
    },
    add() {
      this.itemAddEdit = {};
    },
    edit() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.itemAddEdit = { EntryId: this.currentrow.EntryId };
    },
    deleteItem() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.$confirm(
        `将删除配件名称为【${this.currentrow.PartsName}】的配件信息, 是否继续?`,
        "提示信息",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          cancelButtonClass: "el-button--canale",
          type: "warning",
        }
      )
        .then(() => {
          this.$delete("AccessoryEntryRecords/DeleteAccessoryStorage", {
            EntryId: this.currentrow.EntryId,
          }).then(() => {
            this.$message.success("删除成功");
            this.$refs.list.getTableData();
          });
        })
        .catch(() => {});
    },
    show() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.itemShow = { EntryId: this.currentrow.EntryId };
    },
    out() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.$confirm(
        `确定将配件名称为【${this.currentrow.PartsName}】的配件出库, 是否继续?`,
        "提示信息",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          cancelButtonClass: "el-button--canale",
          type: "warning",
        }
      )
        .then(() => {
          this.$put("AccessoryEntryRecords/OutAccessoryStorage", {
            EntryId: this.currentrow.EntryId,
          }).then(() => {
            this.$message.success("出库成功！");
            this.$refs.list.getTableData();
          });
        })
        .catch(() => {});
    },
  },
};
</script>
  
  <style>
</style>